import { TURKEY_PROVINCE_NAMES } from './turkeyProvinceCenters';

/** Kısa / eski il adları → resmi il adı */
const CITY_ALIASES = {
  afyon: 'Afyonkarahisar',
  afyonkarahisar: 'Afyonkarahisar',
  icel: 'Mersin',
  'içel': 'Mersin',
};

/** API `city` alanı (string veya { name }). */
export function getItemCity(item) {
  if (!item || typeof item !== 'object') return '';
  const raw = item.city ?? item.cityName ?? item.sehir ?? item.il ?? '';
  if (raw && typeof raw === 'object') {
    return String(raw.name || raw.title || raw.cityName || raw.label || '').trim();
  }
  if (raw == null || raw === '') return '';
  return String(raw).trim();
}

export function normalizeCityKey(value) {
  return String(value || '').trim().toLocaleLowerCase('tr-TR');
}

export function canonicalCityName(raw, knownNames = TURKEY_PROVINCE_NAMES) {
  const trimmed = String(raw || '').trim();
  if (!trimmed) return '';
  const key = normalizeCityKey(trimmed);
  if (CITY_ALIASES[key]) return CITY_ALIASES[key];
  const match = Array.isArray(knownNames)
    ? knownNames.find((name) => normalizeCityKey(name) === key)
    : null;
  return match || trimmed;
}

export function citiesMatch(a, b, knownNames = TURKEY_PROVINCE_NAMES) {
  const left = canonicalCityName(a, knownNames);
  const right = canonicalCityName(b, knownNames);
  if (!left || !right) return false;
  return normalizeCityKey(left) === normalizeCityKey(right);
}

export function resolveItemCity(item, knownNames = TURKEY_PROVINCE_NAMES) {
  return canonicalCityName(getItemCity(item), knownNames);
}

/** Seçili şehir yoksa tüm maddeler; varsa yalnızca API `city` alanına göre süzülür. */
export function filterItemsByCity(items, selectedCity, knownNames = TURKEY_PROVINCE_NAMES) {
  if (!Array.isArray(items)) return [];
  if (!normalizeCityKey(selectedCity)) return items;
  return items.filter((item) => citiesMatch(resolveItemCity(item, knownNames), selectedCity, knownNames));
}

/** Yalnızca maddelerin API `city` değerleri (benzersiz, alfabetik). */
export function collectCityOptions(items, knownNames = TURKEY_PROVINCE_NAMES) {
  const seen = new Map();
  if (Array.isArray(items)) {
    for (const item of items) {
      const raw = resolveItemCity(item, knownNames);
      if (!raw) continue;
      const key = normalizeCityKey(raw);
      if (!key || seen.has(key)) continue;
      seen.set(key, raw);
    }
  }
  return Array.from(seen.values()).sort((a, b) => a.localeCompare(b, 'tr'));
}

/** title/ satırına itemPublic/ `city` değerini id ile yazar. */
export function mergeCityById(items, sourceRows, knownNames = TURKEY_PROVINCE_NAMES) {
  if (!Array.isArray(items)) return [];
  const cityById = new Map();
  if (Array.isArray(sourceRows)) {
    for (const row of sourceRows) {
      if (row?.id == null) continue;
      const city = getItemCity(row);
      if (city) cityById.set(row.id, city);
    }
  }

  return items.map((row) => {
    const city = getItemCity(row) || cityById.get(row.id) || '';
    const resolved = canonicalCityName(city, knownNames);
    return resolved ? { ...row, city: resolved } : { ...row, city: city || row.city };
  });
}
